import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import { Redirect } from 'react-router-dom'
import moment from 'moment'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography'
import DecisionSelect from '../../DecisionSelect'
import DecisionSessionListView from './SessionList/SessionListView'
import { getSessionsByDecisionId } from '../../../../api/'

const styles = theme => ({
  highEmphasis: { color: theme.typography.highEmphasis },
  root: { flexGrow: 1 },
  progress: { margin: theme.spacing.unit * 2 },
  textCenter: { textAlign: 'center' },
  well: {
    padding: '12px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #e3e3e3',
    borderRadius: '0px',
    boxShadow: 'inset 0 1px 1px rgba(0,0,0,.05)'
  }
})

class SessionsByDecision extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sessions: [],
      decisionId: '',
      loading: false,
      error: null,
      touched: false
    }
  }

  handleChange = event => {
    const decisionId = event.target.value
    if (this.state.decisionId !== decisionId) {
      this.setState({ loading: true })
      getSessionsByDecisionId(decisionId)
        .then(sessions => {
          this.setState({
            sessions: sessions.map(this.setSessionData),
            decisionId,
            loading: false,
            touched: true
          })
        })
        .catch(error => this.setState({ error }))
    }
  }

  setSessionData = session => {
    session.startTime = session.startTime.length > 0 ? moment(new Date(session.startTime)).format('MM/DD/YY') : null
    session.endTime = session.endTime.length > 0 ? moment(new Date(session.endTime)).format('MM/DD/YY') : null
    session.isComplete = session.isComplete ? 'Yes' : 'No'
    session.lastScreenSaved = this.capitalizeScreen(session.lastScreenSaved)
    return session
  }

  capitalizeScreen = val => {
    if (val.length) {
      const cap = val[0].toUpperCase()
      const rest = val.substring(1)
      return `${cap}${rest}`
    }
    return val
  }

  renderLoader = classes => (
    <div className={this.props.classes.textCenter}>
      <CircularProgress className={this.props.classes.progress} />
    </div>
  )
  
  renderSessionList = () => (
    <DecisionSessionListView 
      recallSession={this.props.recallSession}
      sessions={this.state.sessions} 
    /> 
  )

  renderNoData = () => (
    <div className={this.props.classes.well}>
      <Typography variant="body2" className={this.props.classes.textCenter}>
        {this.props.t('No Sessions or Reports Found')}
      </Typography>
    </div>
  )

  render() {
    const { sessions, loading, touched, error } = this.state
    const { availableDecisions, classes, t } = this.props
    const { handleChange } = this

    if (error) {
      return <Redirect to='/notice/500' />
    }

    return (
      <Grid
        container
        justify="center"
        spacing={24}
      >
        <Grid item xs={10}>
          <Typography variant="subheading">
            <span className={classes.highEmphasis}>
              {t('Recall Session or Report by Decision')}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <DecisionSelect 
            decisions={availableDecisions} 
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={10}>
          {loading && this.renderLoader()} {/* Loading */}
          {sessions.length > 0 && !loading && touched && this.renderSessionList()} {/* Decision Has Data */}
          {sessions.length === 0 && !loading && touched && this.renderNoData()} {/* Decision No Data */}
        </Grid>
      </Grid>
    )
  }
}

SessionsByDecision.propTypes = {
  availableDecisions: PropTypes.object,
  class: PropTypes.object,
  t: PropTypes.func
}


export default compose(
  translate(),
  withStyles(styles)
)(SessionsByDecision)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/ByDecision.js